
import { Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ElBadgeLevel1: () => import('@/assets/svg/badge-level-1.svg'),
    ElBadgeLevel2: () => import('@/assets/svg/badge-level-2.svg'),
    ElBadgeLevel3: () => import('@/assets/svg/badge-level-3.svg'),
    ElBadgeLevel4: () => import('@/assets/svg/badge-level-4.svg'),
    ElBadgeLevel5: () => import('@/assets/svg/badge-level-5.svg'),
    IconCheck: () => import('@/assets/svg/check.svg'),
    TimelineAction: () => import('./_action.vue'),
    TimelineTestEntry: () => import('./_test-entry.vue'),
    TimelinePeriod: () => import('./_period.vue'),
    TimelinePeriodEntry: () => import('./_period-entry.vue'),
    ElMessage: () => import('@/components/parts/ElMessage.vue'),
    DeviceAdvice: () => import('@/components/testResults/device-advice.vue'),
    ElLevelProgression: () => import('@/components/parts/ElLevelProgression.vue'),
  },
})
export default class Timeline extends Vue {
  @Getter('user/dashboardData') dashboardData: DashboardData | undefined;

  @Getter('user/current') user: User | undefined;

  levels: any = [];

  levelENUMS: { [key: string]: string } = {
    1: 'level_one',
    2: 'level_two',
    3: 'level_three',
    4: 'level_four',
    5: 'level_five',
  };

  @Watch('dashboardData', { immediate: true })
  dataChanged(value: DashboardData) {
    if (value) {
      this.levels = JSON.parse(JSON.stringify(value.levels)).reverse();
    }
  }
}
